import {createAction} from "@reduxjs/toolkit";

export const setSearchFunction = createAction('SET_SEARCH_FUNCTION');